<template>
<div class="chapter">
<div class="inner_page">
<div class="ibox">
<p class="ChapTitle1" id="toc1">I<span class="small">NTRODUCTION</span></p>
<p class="intro-txt"><span class="drop-cap">E</span>ach season of the year holds its own special delight for me. Inspiration comes from all of the sounds, smells, colors, and light that the seasons allow us to enjoy. The turning of the seasons can enable us to cultivate our own creativity and share with others how we see the beauty that surrounds us. In this book I wanted to branch out and fill the pages with projects that are not only lovely to look at but have a unique functionality for different times of the year. The projects have their own seasonal qualities and have been a large part of my life as the writing and stitching have come together. As you take the time to browse through these pages, know that I appreciate how precious time is and am thrilled that you chose to spend it here.</p>
<p class="fig"><img alt="" src="images/pg7_1.jpg"/></p>
<p class="fig"><img alt="" src="images/pg8_1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_chapter01.vue?242ee5d3